export const normalizePhone = (value) => {
  const raw = value?.toString().trim() || ''
  if (!raw) return null

  const digits = raw.replace(/\D/g, '')
  if (!digits) return null

  if (digits.startsWith('056')) {
    return `+${digits.slice(1)}`
  }

  if (digits.length === 8) {
    return `+569${digits}`
  }

  if (!raw.startsWith('+56') && digits.length === 9) {
    return `+56${digits}`
  }

  if (digits.length === 11 && digits.startsWith('56')) {
    return `+${digits}`
  }

  if (digits.length >= 11 && !digits.startsWith('56')) {
    return `+${digits}`
  }

  if (raw.startsWith('+')) {
    return `+${digits}`
  }

  return digits
}

export const isValidInternationalPhone = (value) => {
  const raw = value?.toString().trim() || ''
  if (!raw) return true

  const normalized = normalizePhone(raw)
  if (!normalized) return false

  return /^\+[1-9]\d{6,14}$/.test(normalized)
}
